import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  IoIosAddCircleOutline,
  IoIosArrowBack,
  IoMdClose,
} from "react-icons/io";
import { IoSearchSharp } from "react-icons/io5";
import { MdOutlineViewColumn } from "react-icons/md";
import { SlOptionsVertical } from "react-icons/sl";

// import CadastroContribuinteModal from "../../components/CadastroContribuinteModal/cadastroContribuinteModal";
import InputComponent from "../../components/Input/input";
import { GetContribuinteDto } from "../../shared/dtos/Contribuinte.dto";
import contribuinteService from "../../services/ContribuinteService";
import loadSCGif from "../../assets/load_SC.gif";
import "../../shared/styles/global.scss";
import Button from "../../components/Button/button";
import {
  ContainerButtons,
  ContainerFilter,
  LoadingContainer,
  MainContainer,
} from "./style";
import { Colors } from "../../shared/colors/colors";
import {
  ButtonAction,
  MenuTable,
  MenuTableDivider,
  MenuTableItem,
  Table,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
  TableContainer,
} from "../../components/Table/styles";
import { Dropdown } from "react-bootstrap";
import { Label } from "../../components/Label/styles";
import Pagination from "../../components/Pagination/pagination";
import {
  GrayTitle,
  LoadingGif,
  LoadingOverlay,
  StyledHR,
} from "../../shared/styles/global.styles";
import {
  DropdownDivider,
  DropdownScroll,
} from "../../components/Dropdowns/styles";
import { LiaMoneyCheckAltSolid, LiaWalletSolid } from "react-icons/lia";
import CadastroParcelasVariosContribuintes from "../../components/CadastroParcelasVariosContribuintes/CadastroParcelasVariosContribuintes";
import { useAuth } from "../../AuthContext/AuthContext";
import { ModulosEnum } from "../../shared/enum/modulos.enum";
import { PermissoesEnum } from "../../shared/enum/permicao.enum";

const ContribuintesList = () => {
  const { checkPermission } = useAuth();
  const navigate = useNavigate();
  const menuRefsMap = useRef<Map<number, HTMLDivElement | null>>(new Map());
  const defaultColumns = [
    "CPF",
    "Nome",
    "Data de Nascimento",
    "Cidade",
    "Celular",
  ];
  const loadVisibleColumns = () => {
    try {
      const savedColumns = sessionStorage.getItem(
        "contribuintesVisibleColumns"
      );
      if (!savedColumns) return defaultColumns;

      const parsedColumns = JSON.parse(savedColumns);
      return ensureDefaultColumns(parsedColumns);
    } catch (error) {
      console.error("Erro ao carregar colunas:", error);
      return defaultColumns;
    }
  };

  const editOnly = checkPermission(
    ModulosEnum.CONTRIBUINTE,
    PermissoesEnum.ESCRITA
  );

  const detailsOnly = !!(
    checkPermission(ModulosEnum.DADOS_PESSOAIS, PermissoesEnum.LEITURA) ||
    checkPermission(ModulosEnum.MOVIMENTACOES, PermissoesEnum.LEITURA) ||
    checkPermission(ModulosEnum.DEPENDENTES, PermissoesEnum.LEITURA) ||
    checkPermission(ModulosEnum.DADOS_FINANCEIROS, PermissoesEnum.LEITURA) ||
    checkPermission(ModulosEnum.FICHA_FINANCEIRA, PermissoesEnum.LEITURA)
  );

  const editReajustFinanceiro = checkPermission(
    ModulosEnum.REAJUSTE_VALORES_FINANCEIROS,
    PermissoesEnum.ESCRITA
  );

  // const [contribuintes, setContribuintes] = useState<GetContribuinteDto[]>([]);
  const [filteredContribuintes, setFilteredContribuintes] = useState<
    GetContribuinteDto[]
  >([]);
  const [
    showCadastroParcelasVariosContribuintes,
    setShowCadastroParcelasVariosContribuintes,
  ] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [totalContribuintes, setTotalContribuintes] = useState(0);
  const [isSearchEmpty, setIsSearchEmpty] = useState(true);
  const [contribuintesVisibleColumns, setVisibleColumns] = useState<string[]>(
    loadVisibleColumns()
  );
  const [tempVisibleColumns, setTempVisibleColumns] = useState<string[]>(
    loadVisibleColumns()
  );
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [isRequest, setIsRequest] = useState(false);
  const [showColumnSelector, setShowColumnSelector] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [selectedContribuinte, setSelectedContribuinte] =
    useState<GetContribuinteDto | null>(null);
  const cpfInputRef = useRef<HTMLInputElement>(null);
  const columnSelectorRef = useRef<HTMLDivElement>(null);
  const [isOpenMenuCollumn, setIsOpenMenuCollumn] = useState(false);
  const [isOpen, setIsOpen] = useState<number | null>(null);
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  // Funções de paginação
  const totalPages = Math.ceil(totalContribuintes / itemsPerPage);

  // Função para garantir que sempre tenhamos pelo menos as colunas padrão
  const ensureDefaultColumns = (columns: string[]) => {
    return columns.length > 0 ? columns : defaultColumns;
  };

  const toggleDropdown = (id: number) => {
    setIsOpen(id === isOpen ? null : id);
  };

  const fetchContribuintes = async (page: number, searchTerm: string) => {
    try {
      setIsRequest(true);
      const response = await contribuinteService.getAllContribuintes(
        page,
        itemsPerPage,
        searchTerm
      );
      // setContribuintes(response.data);
      setFilteredContribuintes(response.data);
      setTotalContribuintes(response.total);
    } catch (error) {
      console.error("Erro ao buscar contribuintes:", error);
      setError("Não foi possível carregar os contribuintes.");
    } finally {
      setIsRequest(false);
      setLoading(false);
    }
  };

  const handleSearchChange = (value: string) => {
    setCurrentPage(1); // volta para a primeira página
    setSearch(value); // atualiza o estado de busca
  };

  const formatCpf = (cpf: string | number): string => {
    return cpf
      .toString()
      .padStart(11, "0")
      .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  };

  // Função para alternar colunas no estado temporário
  const handleColumnToggle = (column: string) => {
    // Se a coluna é padrão, não permite desmarcar
    if (defaultColumns.includes(column)) {
      return;
    }

    setTempVisibleColumns((prev: string[]) => {
      return prev.includes(column)
        ? prev.filter((col) => col !== column)
        : [...prev, column];
    });
  };

  // Função para aplicar as mudanças
  const handleApplyColumns = () => {
    const columnsToSave = ensureDefaultColumns(tempVisibleColumns);
    setVisibleColumns(columnsToSave);
    sessionStorage.setItem(
      "contribuintesVisibleColumns",
      JSON.stringify(columnsToSave)
    );
    setIsOpenMenuCollumn(false);
  };

  const handleSelect = (contribuinte: GetContribuinteDto) =>
    navigate(`/contribuinte`, { state: { contribuinte } });

  const handleAddContribuinte = () => {
    setSelectedContribuinte(null); // Limpa os dados de edição
    // setIsModalOpen(true); // Abre o modal
    navigate("/contribuinte");
  };

  const handleDeleteContribuinte = async (id: number) => {
    try {
      // Exibe o modal de confirmação do SweetAlert2
      const result = await Swal.fire({
        title: "Tem certeza?",
        text: "Você deseja realmente excluir este contribuinte?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
        reverseButtons: true, // Inverte os botões para dar destaque ao cancelar
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Aguarde...",
          text: "Excluindo o contribuinte.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        await contribuinteService.deleteContribuinte(id);
        await fetchContribuintes(1, search);
        const response = await contribuinteService.getAllContribuintes(
          1,
          itemsPerPage,
          search
        );
        if (response.data.length === 0) {
          setFilteredContribuintes([]); // Limpa a lista de contribuintes filtrados
          setSearch(""); // Limpa o input de busca
          fetchContribuintes(1, search);
        } else {
          setFilteredContribuintes(response.data);
        }
        
        // else {
        //   setContribuintes((prev) => prev.filter((contribuinte) => contribuinte.id !== id));
        // }

        // Exibe mensagem de sucesso
        Swal.fire({
          title: "Excluído!",
          text: "O contribuinte foi excluído com sucesso.",
          icon: "success",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // Opcional: mensagem ao cancelar a exclusão
        Swal.fire({
          title: "Cancelado",
          text: "A exclusão foi cancelada.",
          icon: "info",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
      }
    } catch (error) {
      console.error("Erro ao excluir contribuinte:", error);

      // Exibe mensagem de erro caso a exclusão falhe
      Swal.fire({
        title: "Erro!",
        text: "Não foi possível excluir o contribuinte. Por favor, tente novamente.",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
    }
  };

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    fetchContribuintes(pageNumber, search); // Atualiza os dados para a página selecionada
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        columnSelectorRef.current &&
        !columnSelectorRef.current.contains(event.target as Node)
      ) {
        setShowColumnSelector(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    fetchContribuintes(currentPage, search);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownMenuRef.current &&
        !dropdownMenuRef.current.contains(event.target as Node)
      ) {
        setIsOpenMenuCollumn(false); // Fecha o dropdown
      }
    };

    // Adiciona o event listener quando o menu estiver aberto
    if (isOpenMenuCollumn) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Limpeza do event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpenMenuCollumn]);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(Math.max(totalPages, 1)); // Garante que a página seja válida
    }
  }, [totalPages]);

  useEffect(() => {
    if (isOpenMenuCollumn) {
      setTempVisibleColumns(contribuintesVisibleColumns); // Inicializa o estado temporário com as colunas visíveis atuais
    }
  }, [isOpenMenuCollumn, contribuintesVisibleColumns]);

  useEffect(() => {
    setCurrentPage(1);
    fetchContribuintes(1, search);
  }, [search]);

  return (
    <div className="custom-container important" style={{ overflowX: "auto" }}>
      <MainContainer>
        <GrayTitle>Contribuintes Titulares</GrayTitle>
        <StyledHR />

        {loading ? (
          <LoadingOverlay>
            <LoadingGif src={loadSCGif} alt="Carregando..." />
          </LoadingOverlay>
        ) : (
          <>
            <Label htmlFor="cpf-search" id="form-label">
              Pesquisar por Nome ou CPF:
            </Label>
            <ContainerFilter>
              <InputComponent
                type="text"
                id="cpf-search"
                ref={cpfInputRef}
                value={search}
                onChange={(e) => handleSearchChange(e.target.value)}
                placeholder="Busque por Nome ou CPF do contribuinte"
                autoFocus
                maxLength={45}
                color="black"
                width={399}
                iconLeft={
                  isSearchEmpty ? (
                    <IoSearchSharp size={24} color={Colors.inputIcon} />
                  ) : (
                    <IoIosArrowBack size={24} color={Colors.inputIcon} />
                  )
                }
                onIconLeftClick={() => {
                  if (!isSearchEmpty) {
                    setSearch("");
                    setIsSearchEmpty(true);
                    setCurrentPage(1);
                    fetchContribuintes(1, "");
                  }
                }}
                className="no-outline"
              />

              <ContainerButtons>
                <Button
                  schemaButton="out-primary"
                  action={() => setIsOpenMenuCollumn(!isOpenMenuCollumn)}
                  icon={
                    <MdOutlineViewColumn
                      size={20}
                      style={{ marginRight: "8px" }}
                    />
                  }
                >
                  Colunas
                </Button>

                <Dropdown.Menu
                  ref={dropdownMenuRef}
                  show={isOpenMenuCollumn}
                  style={{ marginTop: "50px" }}
                >
                  <DropdownScroll>
                    {[
                      "CPF",
                      "Nome",
                      "Email",
                      "Sexo",
                      "RG",
                      "Data de Nascimento",
                      "CEP",
                      "Endereço",
                      "Complemento",
                      "Bairro",
                      "Cidade",
                      "Telefone Residencial",
                      "Telefone Comercial",
                      "Telefone Recado",
                      "Celular",
                    ].map((column, index, array) => (
                      <React.Fragment key={column}>
                        {!defaultColumns.includes(column) && (
                          <Dropdown.Item
                            eventKey="1"
                            onClick={() => handleColumnToggle(column)}
                            style={{ color: Colors.primary }}
                          >
                            <img
                              src={
                                tempVisibleColumns.includes(column)
                                  ? "/images/checkbox-marked.svg"
                                  : "/images/checkbox-blank-outline.svg"
                              }
                              alt={
                                tempVisibleColumns.includes(column)
                                  ? defaultColumns.includes(column)
                                    ? "Bloqueado"
                                    : "Selecionado"
                                  : "Não selecionado"
                              }
                              className="checkbox-image"
                            />
                            <label>{column}</label>
                            {array
                              .filter((col) => !defaultColumns.includes(col))
                              .indexOf(column) <
                              array.filter(
                                (col) => !defaultColumns.includes(col)
                              ).length -
                                1 && <DropdownDivider />}
                          </Dropdown.Item>
                        )}
                      </React.Fragment>
                    ))}
                  </DropdownScroll>
                  {JSON.stringify(tempVisibleColumns.sort()) !==
                    JSON.stringify(contribuintesVisibleColumns.sort()) && (
                    <Dropdown.Item>
                      <MenuTableDivider />
                      <Button
                        schemaButton="with-margin"
                        action={handleApplyColumns}
                      >
                        Aplicar
                      </Button>
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>

                {editOnly && (
                  <>
                    {/* <Button
                      schemaButton="full-primary"
                      action={() =>
                        setShowCadastroParcelasVariosContribuintes(true)
                      }
                      icon={
                        <LiaMoneyCheckAltSolid
                          size={20}
                          style={{ marginRight: "8px" }}
                        />
                      }
                    >
                      Cadastrar parcelas
                    </Button> */}
                    <Button
                      schemaButton="full-primary"
                      action={() => handleAddContribuinte()}
                      icon={
                        <IoIosAddCircleOutline
                          size={20}
                          style={{ marginRight: "8px" }}
                        />
                      }
                    >
                      Cadastrar contribuinte
                    </Button>
                  </>
                )}

                {/* {editReajustFinanceiro && (
                  <Button
                    schemaButton="full-primary"
                    action={() => navigate("/reajuste-valores-financeiro")}
                    icon={
                      <LiaWalletSolid
                        size={20}
                        style={{ marginRight: "8px" }}
                      />
                    }
                  >
                    Reajuste Valores Financeiros
                  </Button>
                )} */}

                {showCadastroParcelasVariosContribuintes && editOnly && (
                  <CadastroParcelasVariosContribuintes
                    onClose={() =>
                      setShowCadastroParcelasVariosContribuintes(false)
                    } // Fechar o modal
                    show={showCadastroParcelasVariosContribuintes}
                  />
                )}
              </ContainerButtons>
            </ContainerFilter>
            <StyledHR />
            {error ? (
              <div
                id="erro-mensagem"
                className="alert alert-danger"
                role="alert"
              >
                {error}
              </div>
            ) : (
              <>
                <TableContainer>
                  {isRequest ? (
                    <LoadingContainer>
                      <LoadingGif src={loadSCGif} alt="Carregando..." />
                    </LoadingContainer>
                  ) : (
                    <div className="table-wrapper">
                      <Table id="contribuintes-tabela">
                        <TableHead>
                          <TableRow>
                            {contribuintesVisibleColumns.includes("CPF") && (
                              <TableHeader>CPF</TableHeader>
                            )}
                            {contribuintesVisibleColumns.includes("Nome") && (
                              <TableHeader>Nome</TableHeader>
                            )}
                            {contribuintesVisibleColumns.includes("Email") && (
                              <TableHeader>Email</TableHeader>
                            )}
                            {contribuintesVisibleColumns.includes("Sexo") && (
                              <TableHeader>Sexo</TableHeader>
                            )}
                            {contribuintesVisibleColumns.includes("RG") && (
                              <TableHeader>RG</TableHeader>
                            )}
                            {contribuintesVisibleColumns.includes(
                              "Data de Nascimento"
                            ) && <TableHeader>Data de Nascimento</TableHeader>}
                            {contribuintesVisibleColumns.includes("CEP") && (
                              <TableHeader>CEP</TableHeader>
                            )}
                            {contribuintesVisibleColumns.includes(
                              "Endereço"
                            ) && <TableHeader>Endereço</TableHeader>}
                            {contribuintesVisibleColumns.includes(
                              "Complemento"
                            ) && <TableHeader>Complemento</TableHeader>}
                            {contribuintesVisibleColumns.includes("Bairro") && (
                              <TableHeader>Bairro</TableHeader>
                            )}
                            {contribuintesVisibleColumns.includes("Cidade") && (
                              <TableHeader>Cidade</TableHeader>
                            )}
                            {contribuintesVisibleColumns.includes(
                              "Telefone Residencial"
                            ) && (
                              <TableHeader>Telefone Residencial</TableHeader>
                            )}
                            {contribuintesVisibleColumns.includes(
                              "Telefone Comercial"
                            ) && <TableHeader>Telefone Comercial</TableHeader>}
                            {contribuintesVisibleColumns.includes(
                              "Telefone Recado"
                            ) && <TableHeader>Telefone Recado</TableHeader>}
                            {contribuintesVisibleColumns.includes(
                              "Celular"
                            ) && <TableHeader>Celular</TableHeader>}
                            {(editOnly || detailsOnly) && (
                              <TableHeader>Ações</TableHeader>
                            )}
                          </TableRow>
                        </TableHead>
                        <tbody>
                          {filteredContribuintes.length > 0 ? (
                            filteredContribuintes.map((contribuinte) => (
                              <TableRow key={contribuinte.id}>
                                {contribuintesVisibleColumns.includes(
                                  "CPF"
                                ) && (
                                  <TableData>
                                    {formatCpf(contribuinte.cpfCin)}
                                  </TableData>
                                )}
                                {contribuintesVisibleColumns.includes(
                                  "Nome"
                                ) && <TableData>{contribuinte.nome}</TableData>}
                                {contribuintesVisibleColumns.includes(
                                  "Email"
                                ) && (
                                  <TableData>{contribuinte.email}</TableData>
                                )}
                                {contribuintesVisibleColumns.includes(
                                  "Sexo"
                                ) && (
                                  <TableData>
                                    {contribuinte.sexo === 1
                                      ? "Masculino"
                                      : "Feminino"}
                                  </TableData>
                                )}
                                {contribuintesVisibleColumns.includes("RG") && (
                                  <TableData>{contribuinte.rg}</TableData>
                                )}
                                {contribuintesVisibleColumns.includes(
                                  "Data de Nascimento"
                                ) && (
                                  <TableData>
                                    {contribuinte.dataNascimento
                                      ? new Date(
                                          contribuinte.dataNascimento
                                        ).toLocaleDateString("pt-BR", {
                                          timeZone: "UTC",
                                        })
                                      : "Data não disponível"}
                                  </TableData>
                                )}
                                {contribuintesVisibleColumns.includes(
                                  "CEP"
                                ) && <TableData>{contribuinte.cep}</TableData>}
                                {contribuintesVisibleColumns.includes(
                                  "Endereço"
                                ) && (
                                  <TableData>{`${contribuinte.endereco}, ${contribuinte.numeroResidencial}`}</TableData>
                                )}
                                {contribuintesVisibleColumns.includes(
                                  "Complemento"
                                ) && (
                                  <TableData>
                                    {contribuinte.complementoEndereco}
                                  </TableData>
                                )}
                                {contribuintesVisibleColumns.includes(
                                  "Bairro"
                                ) && (
                                  <TableData>{contribuinte.bairro}</TableData>
                                )}
                                {contribuintesVisibleColumns.includes(
                                  "Cidade"
                                ) && (
                                  <TableData>
                                    {contribuinte.cidade === null
                                      ? ""
                                      : contribuinte.uf === null
                                      ? contribuinte.cidade
                                      : `${contribuinte.cidade} - ${contribuinte.uf}`}
                                  </TableData>
                                )}
                                {contribuintesVisibleColumns.includes(
                                  "Telefone Residencial"
                                ) && (
                                  <TableData>
                                    {contribuinte.telefoneResidencial}
                                  </TableData>
                                )}
                                {contribuintesVisibleColumns.includes(
                                  "Telefone Comercial"
                                ) && (
                                  <TableData>
                                    {contribuinte.telefoneComercial}
                                  </TableData>
                                )}
                                {contribuintesVisibleColumns.includes(
                                  "Telefone Recado"
                                ) && (
                                  <TableData>
                                    {contribuinte.telefoneRecado}
                                  </TableData>
                                )}
                                {contribuintesVisibleColumns.includes(
                                  "Celular"
                                ) && (
                                  <TableData>{contribuinte.celular}</TableData>
                                )}
                                {(editOnly || detailsOnly) && (
                                  <TableData
                                    key={`actions-${contribuinte.id}`}
                                    style={{
                                      position: "relative",
                                      overflow: "visible",
                                    }}
                                  >
                                    <ButtonAction
                                      onClick={() =>
                                        toggleDropdown(contribuinte.id)
                                      }
                                    >
                                      {isOpen === contribuinte.id ? (
                                        <IoMdClose
                                          cursor={"pointer"}
                                          size={20}
                                          style={{ color: Colors.primary }}
                                        />
                                      ) : (
                                        <SlOptionsVertical
                                          cursor={"pointer"}
                                          size={20}
                                          style={{ color: Colors.primary }}
                                        />
                                      )}
                                    </ButtonAction>

                                    <MenuTable
                                      ref={(el: HTMLDivElement | null) => {
                                        menuRefsMap.current.set(
                                          contribuinte.id,
                                          el
                                        );
                                      }}
                                      show={isOpen === contribuinte.id}
                                      align="start"
                                      isLastRows={
                                        filteredContribuintes.length > 0 &&
                                        filteredContribuintes.indexOf(
                                          contribuinte
                                        ) >=
                                          filteredContribuintes.length -
                                            Math.ceil(
                                              filteredContribuintes.length / 2
                                            )
                                      }
                                    >
                                      {detailsOnly && (
                                        <>
                                          <MenuTableItem
                                            eventKey="1"
                                            onClick={() =>
                                              handleSelect(contribuinte)
                                            }
                                          >
                                            Detalhes
                                          </MenuTableItem>
                                          <MenuTableDivider />
                                        </>
                                      )}
                                      {editOnly && (
                                        <MenuTableItem
                                          eventKey="3"
                                          onClick={() =>
                                            handleDeleteContribuinte(
                                              contribuinte.id
                                            )
                                          }
                                        >
                                          Excluir
                                        </MenuTableItem>
                                      )}
                                    </MenuTable>
                                  </TableData>
                                )}
                              </TableRow>
                            ))
                          ) : (
                            <tr>
                              <TableData
                                colSpan={contribuintesVisibleColumns.length + 1}
                                className="text-center"
                              >
                                Nenhum contribuinte encontrado.
                              </TableData>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </TableContainer>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </>
            )}
          </>
        )}
      </MainContainer>
    </div>
  );
};

export default ContribuintesList;
